import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { Refine } from '@refinedev/core';
import routerProvider from '@refinedev/react-router-v6';
import { ErrorBoundary } from '@sentry/react';
import 'mantine-datatable/styles.layer.css';
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from './AllRoutes';
import { createMantineTheme, cssVariableResolver } from './UI/theme/theme';
import { GenericErrorPage } from './error/GenericErrorPage';
import { FeatureFlagProvider } from './feature-flags/FeatureFlagProvider';
import { authProvider } from './providers/authProvider';
import { dataProvider } from './providers/dataProvider';
import { PageViewTracker } from './tracking/PageViewTracker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

function App() {
  const theme = createMantineTheme();

  return (
    <MantineProvider theme={theme} cssVariablesResolver={cssVariableResolver}>
      <Notifications />
      <BrowserRouter>
        <ErrorBoundary fallback={({ error }) => <GenericErrorPage error={error} />}>
          <Refine
            dataProvider={dataProvider}
            authProvider={authProvider}
            routerProvider={routerProvider}
            options={{
              reactQuery: {
                clientConfig: {
                  defaultOptions: {
                    queries: {
                      retry: (failureCount: number, error: unknown) => {
                        if (error instanceof Response) {
                          if (error.status === 401 || error.status === 403) {
                            return false;
                          }
                        }

                        return failureCount < 3;
                      },
                    },
                  },
                },
              },
            }}
          >
            <PageViewTracker />
            <AllRoutes />
          </Refine>
        </ErrorBoundary>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default function AppWithFlags() {
  return (
    <FeatureFlagProvider>
      <App />
    </FeatureFlagProvider>
  );
}
